export { PropertySol } from "./PropertySol";
